import { type MCPServerInfo } from '../../types';

const StarWarsServer: MCPServerInfo = {
  serverId: 'STAR_WARS',
  name: 'Star Wars',
  slug: 'star-wars',
  description: 'Star Wars MCP Server',
  source: {
    sourceType: 'REPOSITORY',
    type: 'COMMUNITY',
    repositoryUrl: 'https://github.com/N8Maynard91/mcp-starwars',
    commitSha: 'latest',
    packageType: 'npm',
    packageName: '@n8maynard91/mcp-starwars'
  },
  authenticationType: 'NONE',
  serverConfig: {
    required: [],
    properties: {}
  },
  installConfig: {
    required: [],
    properties: {}
  },
  deprecated: true
};

export default StarWarsServer;
